<div class="check-mobile-wrapper">
  <div class="check-mobile-container">
    <div class="logo">
      <img [src]="(platformSettings$ | async)?.logoUrl" />
    </div>

    <div class="title">{{ 'CHECK_MOBILE_PHONE.TITLE' | translate }}</div>

    <div class="text">{{ 'CHECK_MOBILE_PHONE.DESCRIPTION' | translate }}</div>

    <div class="text">{{ 'CHECK_MOBILE_PHONE.DOWNLOAD' | translate }}</div>

    <a class="link" (click)="goBack()">[{{ 'CHECK_MOBILE_PHONE.LOGIN_HERE' | translate }}]</a>

    @if ((platformSettings$ | async)?.linkAppStore || (platformSettings$ | async)?.linkPlayMarket) {
    <lin-app-stote-and-google-badges
      [linkAppStore]="(platformSettings$ | async)?.linkAppStore"
      [linkPlayMarket]="(platformSettings$ | async)?.linkPlayMarket"
    ></lin-app-stote-and-google-badges>
    }
  </div>
</div>
